// Hatching meter — cartographic shading legend, not a SaaS bar.
// Ten cells; each cell is empty / partial / full based on the
// fraction of the batch that has graduated.

interface Props {
  /** 0..1 — fraction of cards in the graduated state. */
  ratio: number;
  cells?: number;
}

export function CoverageMeter({ ratio, cells = 10 }: Props) {
  const filled = ratio * cells;
  return (
    <div
      className="flex items-center gap-0.5"
      aria-label={`${Math.round(ratio * 100)}% graduated`}
    >
      {Array.from({ length: cells }, (_, i) => {
        const local = filled - i;
        const fill = local >= 1 ? "full" : local >= 0.5 ? "partial" : "empty";
        return <span key={i} className="n5-hatch-cell" data-fill={fill} />;
      })}
    </div>
  );
}
